import React from 'react';
import { createRoot } from 'react-dom/client';
import AppWithMSAL from './AppWithMSAL';

const root = createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<AppWithMSAL />
	</React.StrictMode>
);
